<template>
  <div class="stepsdemo-content">
    <Card>
      <template #title> Calendário do Evento </template>
      <template #subtitle>
        Informe os dias correspondentes ao cronograma do seu evento.
      </template>
      <template #content>
        <div class="p-fluid">
          <div style="background-color: " class="grid">
            <event-calendar-form
              :calendarsObj="calendars"
              :submitted="submitted"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="grid grid-nogutter justify-content-between">
          <Button
            label="Voltar"
            @click="prevPage()"
            icon="pi pi-angle-left"
            iconPos="left"
          />
          <Button
            label="Concluir"
            @click="complete(!v$.$invalid)"
            class="p-button-success"
            icon="pi pi-angle-right"
            iconPos="right"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";
import eventCalendarForm from "../../calendar/components/event-calendar-form.vue";
import Calendar from "../../../models/internal/calendar";

export default {
  components: { eventCalendarForm },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      submitted: false,
      pageIndex: 2,
      calendars: [new Calendar()],
    };
  },
  created() {
    this.calendars = [];
  },
  validations: {},
  methods: {
    async complete() {
      this.submitted = true;
      if (this.calendars.length === 0) {
        this.$msgInfo("Necessário informar o período do evento.");
        return;
      }

      try {
        this.$emit("complete", {
          calendars: this.calendars,
          pageIndex: this.pageIndex,
        });
      } catch (error) {
        console.error("Erro ao completar:", error);
      }
    },
    prevPage() {
      this.$emit("prevPage", {
        formData: {
          firstname: this.firstname,
          lastname: this.lastname,
          age: this.age,
        },
        pageIndex: this.pageIndex,
      });
    },
  },
};
</script>



